<template>
  <div>
    <b-row>
      <b-col cols="12">
        <h4 class="text-primary text-center">
          <i class="fa-solid fa-whitelist"></i>
          {{ $t('tabs.whitelists.details') }}
        </h4>
      </b-col>

      <b-col cols="12" xl="12">
        <label>{{ $t('columns.orgId') }}</label>
        <organization-select-box v-model="whitelist.orgId"/>
      </b-col>



      <b-col cols="12" xl="12" class="mt-2">
        <label>{{ $t('columns.name') }}</label>
        <b-form-input v-model="whitelist.alias"/>
      </b-col>

      <b-col cols="12" xl="12" class="mt-2">
        <label>{{ $t('columns.ip') }}</label>
        <b-form-input
            v-model="whitelist.ip"
            :state="isValidIp(whitelist.ip)"
            @blur="ipTouched = true"
            placeholder="e.g., 192.168.1.1 or 2001:0db8::1"
        ></b-form-input>
        <b-form-invalid-feedback v-if="ipTouched && !isValidIp(whitelist.ip)">
          {{ $t('validation.invalidIp') }}
        </b-form-invalid-feedback>
      </b-col>

    </b-row>
    <div class="text-center mt-2" style="position: absolute;bottom: 10px; width: 100%">
      <b-button class="d-inline-block" size="sm" variant="outline-warning" >{{$t('operations.reset')}}</b-button>&nbsp;
      <b-button class="d-inline-block" size="sm" variant="outline-success" @click="save">{{$t('operations.save')}}</b-button>
    </div>
  </div>
</template>

<script>
import Whitelist from '@/model/whitelist/Whitelist'
import mixinPermissions from '@/components/mixin/mixinPermissions'
import { mapActions, mapGetters } from 'vuex'
import mixinNotifications from '@/components/mixin/mixinNotifications'
import OrganizationSelectBox from '@/components/widget/select/OrganizationSelectBox'
import BusinessUnitSelectBox from '@/components/widget/select/BusinessUnitSelectBox'
import CountriesSelectBox from '@/components/widget/select/CountriesSelectBox'
import CalendarPicker from '@/components/widget/picker/calendarPicker'
import UserSelectBox from '@/components/widget/select/UserSelectBox';

export default {
  name: 'WhitelistEditDetails',
  components: { UserSelectBox, CalendarPicker, CountriesSelectBox, BusinessUnitSelectBox, OrganizationSelectBox },
  mixins: [mixinPermissions, mixinNotifications],
  data: ()=>({
    whitelist: Whitelist(),

    ipTouched: false
  }),
  props: {
    value: {
      required: true,
      default: () => ({})
    },
    newWhitelist: {
      type: Boolean,
      default: () => false
    }
  },
  watch:{
    value:{
      handler(){
        this.whitelist = Object.assign(Whitelist(), this.value)
      },
      immediate: true
    }
  },
  computed:{
   ...mapGetters('whitelist', [''])
  },
  methods:{
    ...mapActions('whitelist', ['updateWhitelist','createWhitelist']),
    isValidIp(ip) {
      if (!ip) return null;
      const ipv4Pattern =
          /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/;
      const ipv6Pattern =
          /^(([0-9a-fA-F]{1,4}:){7}([0-9a-fA-F]{1,4}|:)|(::1)|::)$/;

      return ipv4Pattern.test(ip.trim()) || ipv6Pattern.test(ip.trim());
    },
    async save() {
      if (this.whitelist.id == null) {
        await this.addWhitelist();
      } else {
        await this.modifyWhitelist();
      }
    },

    async addWhitelist() {
      let $this = this;
      await this.createWhitelist({
        whitelist: this.whitelist
      })
          .catch(err => {
            this.showErrorNotification(this.$t('globalMessages.fetchDataError', { system: this.$t('menu.whitelists') }), err.response.data.error);
          });
      this.showSuccessNotification($this.$t('globalMessages.addDataSuccess', { system: $this.$t('menu.whitelists') }));
      this.$emit('input', this.whitelist);
      this.$emit('close');

      this.refreshTables();
    },
    async modifyWhitelist() {
      let $this = this;

      await this.updateWhitelist({
        whitelist: this.whitelist,
        id: this.whitelist.id
      })
          .catch(err => {
            $this.showErrorNotification($this.$t('globalMessages.fetchDataError', { system: $this.$t('menu.whitelists') }), err.response.data.error);
          });
      this.showSuccessNotification($this.$t('globalMessages.updateDataSuccess', { system: $this.$t('menu.whitelists') }));
      this.$emit('input', this.whitelist);
      this.$emit('updated', this.whitelist.id);
      this.$emit('close');
      this.refreshTables();

    },
  }
}
</script>

<style scoped>

</style>
